<template>
    <div class="login-body">
        <div class="login-panel p-fluid grid custom-login-panel">
            <div class="flex-column col-6">
                <div class="flex align-items-center logo-container center-content">
                    <img
                        :src="'layout/images/full-logo-' + colorScheme + '.png'"
                        class="login-appname login-united-logo"
                    />
                </div>
                <div class="center-content">
                    <h1 v-if="userName" class="welcome-header">Welcome {{ userName }}!</h1>
                    <h1 v-else class="welcome-header">Welcome to Moosehead!</h1>
                    <div class="dropdown-message">
                        <h6 class="mb-3">Please select a client to begin.</h6>
                    </div>
                    <ClientSelector
                        :selectedClient="selectedClient"
                        :clientOptions="clientOptions"
                        @handleSelectedClient="handleSelectedClient($event)"
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="login-footer flex align-items-center custom-footer">
        <AppFooter :colorScheme="colorScheme" />
    </div>
</template>

<script>
import AppFooter from '@/AppFooter.vue';
import ClientSelector from '@/components/listGeneration/ClientSelector.vue';

export default {
    name: 'ClientRequirement',
    components: {
        AppFooter,
        ClientSelector,
    },
    data() {
        return {
            userName: '',
            userDoc: null,
        };
    },
    emits: ['handle-selected-client'],
    props: {
        selectedClient: Object,
        clientOptions: Array,
        colorScheme: String,
    },
    methods: {
        handleSelectedClient(event) {
            this.$emit('handle-selected-client', event);
        },
        onlyOneClient() {
            if (this.clientOptions.length === 1) {
                this.handleSelectedClient(this.clientOptions[0]);
            }
        },
        setUserName() {
            if (this.userDoc) {
                this.userName = this.userDoc.default.display_name;

                if (this.userName && this.userName.includes(' ') && this.userName.split(' ').length <= 2) {
                    this.userName = this.userName.split(' ')[0];
                }
            }
        },
    },
    mounted() {
        this.userDoc = this.$store.state.dbcalls.userDoc;
        this.setUserName();
    },
    watch: {
        clientOptions: {
            handler(newOptions, oldOptions) {
                if (newOptions !== oldOptions) {
                    this.onlyOneClient();
                }
            },
        },
    },
};
</script>

<style scoped lang="scss">
.mb-3 {
    margin-bottom: 3rem !important;
}
.welcome-header {
    margin-bottom: 0.5rem;
}
.center-content {
    justify-content: center;
}
.dropdown-message {
    position: relative;
    margin-bottom: 5%;
}
.custom-login-panel {
    justify-content: center;
    padding-top: 10%;
}
.custom-footer {
    position: absolute;
    bottom: 0%;
}
.login-united-logo {
    position: relative;
    transform: scale(1.5);
    margin-bottom: 2rem;
}
</style>
